import { addDays } from "date-fns";
import AppIcon from "images/brand/customer-app-icon.svg";
import { useState } from "react";
import { useCookies } from "react-cookie";
import { sizes } from "../assets/themes";
import BottomModal from "../components/bottom-modal";
import polyglot from "../utils/polyglot";

const DlAppModal = ({ auto_open, app_store_url, google_play_url, is_ios, is_mobile }) => {
  const [cookies, setCookies] = useCookies(["dlAppModal"]);
  const [modalIsOpen, setModalIsOpen] = useState(cookies.hasPop !== "true");
  const redirectUrl = is_ios ? app_store_url : google_play_url;

  const updateCookies = () => {
    setCookies("hasPop", true, {
      expires: addDays(new Date(), 30),
      SameSite: "Lax",
    });
    setModalIsOpen(false);
  };
  const handleRedirection = () => {
    updateCookies();
    window.open(redirectUrl);
  };

  return (
    <BottomModal
      hasCloseButton
      isOpen={is_mobile && modalIsOpen ? auto_open : false}
      onClose={updateCookies}
      render={() => (
        <div className="d-flex flex-column align-items-center">
          <img
            alt={polyglot.t("downloadAppModal.IconAlt")}
            className="mb-3"
            css={`
              width: ${sizes.size64};
              height: ${sizes.size64};
              object-fit: cover;
            `}
            src={AppIcon}
          />
          <span className="h5 mb-2 text-center">{polyglot.t("downloadAppModal.title")}</span>
          <p className="mb-3 text-center">{polyglot.t("downloadAppModal.body")}</p>
          <button
            className="btn btn-lg btn-primary btn-block"
            onClick={handleRedirection}
            type="button"
          >
            {polyglot.t("downloadAppModal.cta")}
          </button>
        </div>
      )}
      shouldCloseOnOverlayClick={false}
    />
  );
};

export default DlAppModal;
